import React from 'react';

/**
 * AdserverIframe Component
 * Renders an iframe for displaying ads, with a fallback image link if the iframe fails.
 */
const AdserverIframe = () => {
    return (
        <div className="banner2 border-radious5 banner_homepage mb20 mt20 mt-lg-0">
            <iframe
                title="cm2server"
                id="a64f1ca8"
                name="a64f1ca8"
                src="https://cm2.regiohealth.net/cma/www/delivery/afr.php?zoneid=1&amp;cb=INSERT_RANDOM_NUMBER_HERE"
                frameBorder="0"
                scrolling="no"
                width="308"
                height="257"
                allow="autoplay"
            >
                {/* Fallback content for browsers that block iframes */}
                <a
                    href="https://cm2.regiohealth.net/cma/www/delivery/ck.php?n=a75df846&amp;cb=INSERT_RANDOM_NUMBER_HERE"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img
                        src="https://cm2.regiohealth.net/cma/www/delivery/avw.php?zoneid=1&amp;cb=INSERT_RANDOM_NUMBER_HERE&amp;n=a75df846"
                        border="0"
                        alt=""
                    />
                </a>
            </iframe>
        </div>
    );
};

export default AdserverIframe;
